import { ColumnProps } from "antd/lib/table";

export enum ColumnVisibility {
  Visible,
  Hidden,
  Optional
}

export interface ColumnDefinition {
  key: string;
  visibility: ColumnVisibility;
}

export interface ColumnsProvider<T> {
  getPickedColumns: (columns: T[]) => T[];
  getColumns: () => ColumnDefinition[];
}

export class GridColumnsProvider<T> implements ColumnsProvider<ColumnProps<T>> {
  private columnPreferences: ColumnDefinition[];
  constructor(
    columnPreferences: ColumnDefinition[]
  ) {
    this.columnPreferences = columnPreferences;
  }
  public getColumns(): ColumnDefinition[] {
    return this.columnPreferences;
  }
  public getPickedColumns(columns: Array<ColumnProps<T>>) {
    const columnsByKey: { [key: string]: any } = {};
    columns.forEach(x => (columnsByKey[x.key!] = x));

    const pickedColumns = this.getColumns()
      .filter(x => x.visibility !== ColumnVisibility.Hidden)
      .map(x => columnsByKey[x.key]);

    return pickedColumns;
  }
}
